import { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Page } from 'react-pdf/dist/esm/entry.vite';
import { Buttons, Spinner } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import Notify, { AlertTypes } from 'Services/notification';
import { hideModalAction } from 'Store/modules/app/actions';
import useTranslation from 'Hooks/useTranslation';
import { removeOverflow } from 'Styles/utils/utils';
import { downloadCep, downloadPdf } from 'Utils/formatPdf';
import { isNative, openPdfFile } from 'Utils/native';
import { TAX_YEAR } from 'Config';
import * as Styled from '../../styles';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
  standardFontDataUrl: 'standard_fonts/',
};

const Custom = ({
  base64Pdf,
  base64Binary,
  fileType,
}: {
  base64Pdf: string;
  base64Binary: string;
  fileType: string;
}): JSX.Element => {
  const customRef = useRef();
  const { t } = useTranslation(locizeNS.MODALS);
  const [pages, setPages] = useState<number[]>([]);
  const dispatch = useDispatch();
  const onDocumentLoadSuccess = ({ numPages }): void => {
    if (numPages) {
      setPages([...Array(numPages).keys()]);
    }
  };

  const closeModal = (): void => {
    removeOverflow();
    dispatch(hideModalAction());
    setPages([0]);
  };
  const fileName = `TaxDown - Declaracion de la renta ${TAX_YEAR}.pdf`;
  const fileNameCep = `TaxDown - CEP.pdf`;
  const handleMobileDownload = (): void => {
    if (fileType === 'pdf') {
      openPdfFile(fileName, base64Binary);
    } else {
      openPdfFile(fileNameCep, base64Binary);
    }
    Notify.sendNotification(t('PDF.download.success'), AlertTypes.success);
  };

  const handleDownload = (): void => {
    if (fileType === 'pdf') {
      downloadPdf(base64Pdf);
    } else {
      downloadCep(base64Binary);
    }
  };
  return (
    <Styled.Container ref={customRef} id="pdfContainer">
      <Styled.DocumentContainer
        file={base64Pdf}
        onLoadSuccess={onDocumentLoadSuccess}
        options={options}
      >
        {pages.map(pageIndex => (
          <Page
            pageNumber={pageIndex + 1}
            loading={<Spinner size="M" justify="center" />}
            key={pageIndex}
          />
        ))}
      </Styled.DocumentContainer>
      <Styled.ButtonActions justify="center" gap="dimension_16">
        {isNative() ? (
          <Buttons.Classic
            mode="primary"
            onClick={() => handleMobileDownload()}
            testID="app-link"
            label={t('PDF.Download.mobile')}
            size="m"
          />
        ) : (
          <Buttons.Classic
            mode="primary"
            onClick={handleDownload}
            testID="browser-button"
            label={t('PDF.Download')}
            size="m"
          />
        )}

        <Buttons.Classic label={t('PDF.Close')} mode="primary" onClick={closeModal} size="m" />
      </Styled.ButtonActions>
    </Styled.Container>
  );
};

export default Custom;
